// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3DHvp","clinicsSelect":"TableHeading_clinicsSelect__3NT5A"};